<template>
  <v-data-table
    :value="selected"
    :headers="headers"
    :items="value"
    :items-per-page="15"
    :search="search"
    :custom-filter="$options.localeIncludes"
    :loading="loading"
    :loading-text="$t('general.loading')"
    sort-by="dateCreate"
    sort-desc
    show-select
    @input="$emit('update:selected', $event)"
  >
    <template v-slot:[`item.lang`]="{ item }">
      <ag-language-text v-model="item.lang" />
    </template>
    <template v-slot:[`item.dateCreate`]="{ item }">
      <ag-date-text
        :value="item.dateCreate"
        :format="$t('date.dateAndTime')"
      />
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <span v-text="$t(`trainingsession.fields.status.${item.status}`)" />
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn
        color="accent"
        small
        @click="openSession(item.id)"
        v-text="$t('trainingsession.fields.actions.button')"
      />
    </template>
  </v-data-table>
</template>

<script>
import Helpers from 'src/utils/helpers'
import AgLanguageText from 'src/components/common/AgLanguageText'
import AgDateText from 'src/components/common/AgDateText'
import { mapActions } from 'vuex'

export default {
  name: 'SessionList',
  components: {
    AgLanguageText,
    AgDateText,
  },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    selected: {
      type: Array,
      default: () => ([]),
    },
    search: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('trainingsession.fields.session.name'),
          value: 'name',
        },
        {
          text: this.$t('trainingsession.fields.session.code'),
          value: 'code',
        },
        {
          text: this.$t('trainingsession.fields.session.player'),
          value: 'nbPlayer',
          align: 'center',
          filterable: false,
        },
        {
          text: this.$t('general.language'),
          value: 'lang',
          filterable: true,
          align: 'center',
          width: '15%',
        },
        {
          text: this.$t('trainingsession.fields.session.userCreate'),
          value: 'userCreate',
        },
        {
          text: this.$t('trainingsession.fields.session.dateCreate'),
          value: 'dateCreate',
        },
        {
          text: this.$t('trainingsession.fields.session.status'),
          value: 'status',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          filterable: false,
          align: 'center',
          width: '130px',
        },
      ]
    },
  },
  methods: {
    ...mapActions('animation', {
      openSessionList: 'openSessionList',
    }),
    openSession (sessionId) {
      this.openSessionList([sessionId])
      this.$router.replace(`/animation/session/${sessionId}`)
    },
  },
  localeIncludes: Helpers.localeIncludes,
}
</script>
